"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var native_1 = __importDefault(require("styled-components/native"));
var react_native_1 = require("react-native");
var injectStyleProp_1 = require("../utils/injectStyleProp");
var defaultProps = {
    opacity: 1,
    size: 32,
    tintColor: undefined
};
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
var StyledIcon = native_1.default(react_native_1.Image)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", ";\n\t", ";\n\twidth: ", ";\n\theight: ", ";\n"], ["\n\t", ";\n\t", ";\n\twidth: ", ";\n\theight: ", ";\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])), injectStyleProp_1.injectStyleProp('opacity'), injectStyleProp_1.injectStyleProp('tint-color'), function (props) { return props.size; }, function (props) { return props.size; });
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLAtomIcon = function (_a) {
    var source = _a.source, opacity = _a.opacity, size = _a.size, tintColor = _a.tintColor;
    // Renders an icon
    var renderIcon = function () { return (react_1.default.createElement(StyledIcon, { source: source, opacity: opacity, size: size, tintColor: tintColor, resizeMode: 'contain' })); };
    return renderIcon();
};
exports.ATLAtomIcon.defaultProps = defaultProps;
exports.ATLAtomIcon.displayName = 'ATLAtomIcon';
var templateObject_1;
